export function adminContentCampaignShowTabularColumn() {
  return [
    {
      name: 'id',
      title: 'شماره کمپین'
    },
    {
      name: 'status',
      title: 'وضعیت کمپین'
    },
    {
      name: 'attachments',
      title: 'فایل ضمیمه'
    },
    {
      name: 'references_url',
      title: 'سایت مرجع'
    },
    {
      name: 'running_at',
      title: 'تاریخ ثبت'
    },
    {
      name: 'actions',
      title: ''
    }
  ]
}

export function panelContentCampaignShowTabularColumn() {
  return [
    {
      name: 'id',
      title: 'شماره کمپین'
    },
    {
      name: 'title',
      title: 'عنوان کمپین'
    },
    {
      name: 'status',
      title: 'وضعیت کمپین'
    },
    {
      name: 'attachments',
      title: 'فایل ضمیمه',
      value: ''
    },
    {
      name: 'actions',
      title: '',
      class: 'col-shrink'
    }
  ]
}